import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: number;
}

export function ClaudeLogo({ className, size = 24 }: LogoProps) {
  return (
    <img
      src="/claude-logo-png_seeklogo-554534.png"
      alt="Claude"
      width={size}
      height={size}
      className={cn("flex-shrink-0 rounded-sm object-contain", className)}
    />
  );
}

export function ChatGPTLogo({ className, size = 24 }: LogoProps) {
  return (
    <img
      src="/openai-chatgpt-logo-icon-free-png.webp"
      alt="ChatGPT"
      width={size}
      height={size}
      className={cn("flex-shrink-0 rounded-sm object-contain", className)}
    />
  );
}

export function CodexLogo({ className, size = 24 }: LogoProps) {
  return (
    <img
      src="/openai-chatgpt-logo-icon-free-png.webp"
      alt="Codex"
      width={size}
      height={size}
      className={cn("flex-shrink-0 rounded-sm object-contain", className)}
    />
  );
}

export function GeminiLogo({ className, size = 24 }: LogoProps) {
  return (
    <img
      src="/Google_Gemini_icon_2025.svg.png"
      alt="Gemini"
      width={size}
      height={size}
      className={cn("flex-shrink-0 rounded-sm object-contain", className)}
    />
  );
}

export function LocalModelLogo({ className, size = 24 }: LogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={cn("flex-shrink-0", className)}
      fill="none"
    >
      <circle cx="12" cy="12" r="12" fill="#6B7280" />
      <rect x="7" y="8" width="10" height="8" rx="1" stroke="white" strokeWidth="1.5" />
      <path d="M10 15v2M14 15v2M8 17h2M14 17h2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
